
<template>
  <v-row justify="center">
    <v-col cols="12">
      <v-card>
        <v-toolbar color="primary">
          <v-toolbar-title>Остатки товара</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <!--          <v-row class="justify-center">-->
          <v-row>
            <v-col
              cols="12"
              sm="2"
            >
              Период
            </v-col>
            <v-col
              cols="12"
              sm="5"
            >
              <date-picker
                v-model="form.beginPeriod"
                label="Начало периода"
              />
            </v-col>
            <v-col
              cols="12"
              sm="5"
            >
              <date-picker
                v-model="form.endPeriod"
                label="Конец периода"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              sm="2"
            >
              Точки
            </v-col>
            <v-col
              cols="12"
              sm="10"
            >
              <v-autocomplete
                v-model="form.points"
                :items="pointSelection"
                multiple
                chips
                @change="onChoosePoint"
              >
                <template v-slot:prepend-item>
                  <v-list-item
                    ripple
                    @mousedown.prevent
                    @click="onTogglePoints"
                  >
                    <v-list-item-action>
                      <v-icon>
                        {{ iconSelectedPoints }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        Выбрать всё
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2" />
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              sm="2"
            >
              Группировка:
            </v-col>
            <v-col
              cols="12"
              sm="10"
            >
              <v-autocomplete
                v-model="form.nomenclatures"
                :items="nomenclatureSelection"
                multiple
                chips
              >
                <template v-slot:prepend-item>
                  <v-list-item
                    ripple
                    @mousedown.prevent
                    @click="onToggleProducts"
                  >
                    <v-list-item-action>
                      <v-icon>
                        {{ iconSelectedProducts }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        Выбрать всё
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2" />
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              Дополнительно:
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-checkbox
                v-model="showResidualProduct"
                label="Показать только товары с остатком"
                @change="onChangeOption"
              />
            </v-col>
            <v-col cols="12">
              <v-checkbox
                v-model="showNotMovedProduct"
                label="Показать товары без движения (> 30 дней)"
                @change="onChangeOption"
              />
            </v-col>
            <!--            <v-col cols="12">-->
            <!--              <v-checkbox-->
            <!--                v-model="showZeroBalance"-->
            <!--                label="включить нулевые остатки"-->
            <!--                @change="onChangeOption"-->
            <!--              />-->
            <!--            </v-col>-->
          </v-row>
          <!--          </v-row>-->
        </v-card-text>
        <v-card-actions>
          <v-row>
            <v-col cols="6">
              <v-btn
                block
                color="Primary"
                @click="onReport"
              >
                Сформировать отчёт
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                block
                outlined
                color="primary"
              >
                Очистить
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
        <v-divider />
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <h1>
                Сводная отчётность
              </h1>
            </v-col>
            <v-col cols="12">
              <h3>
                Выбрано точек:   {{ chosenPoints }}
              </h3>
            </v-col>
            <v-col cols="12">
              <h3>
                Товаров с остатком: {{ goodsInStock }} из {{ allGoods }}
              </h3>
            </v-col>
            <v-col cols="12">
              <h3>
                Общий остаток {{ commonRemainder }} шт.  на сумму {{ commonBalance }}
              </h3>
            </v-col>
            <v-col cols="12">
              <h3>
                Средняя оборачиваемость: {{ averageTurnoverRatio }}
              </h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :loading="isLoading"
                loading-text="Загружаю данные"
                :headers="headers"
                :items="report.remainderResponses"
                :footer-props="{
                  itemsPerPageText: 'Показывать по',
                  pageText: 'из',
                  itemsPerPageAllText: 'Все',
                }"
                no-data-text="Нет данных для отображения"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import DatePicker from "@/views/loyalty/shared/components/date-picker/DatePicker.vue"
import { JustpayRemainderService } from "@/views/loyalty/shared/services/justpay-remainder-service"

export default {
  name: "RemainderForm",
  components: { DatePicker },
  data: () => ({
    allGoods: 0,
    averageTurnoverRatio: 0,
    chosenPoints: 0,
    commonBalance: 0,
    commonRemainder: 0,
    form: {
      beginPeriod: new Date().toISOString(),
      endPeriod: new Date().toISOString(),
      nomenclatures: [],
      points: [],
    },
    goodsInStock: 0,
    headers: [
      { value: 'pointName', text: 'Точка' },
      { value: 'nomenclatureName', text: 'Товар' },
      { value: 'incomingRemainder', text: 'Входящий остаток' },
      { value: 'revenueCountNomenclatureInPeriod', text: 'Приход' },
      { value: 'countSoldNomenclatureInPeriod', text: 'Расход' },
      { value: 'remainderInPeriod', text: 'Остаток' },
      { value: 'daysOnPoint', text: 'Дней на точке' },
      { value: 'turnoverRatio', text: 'Коэффициент оборачиваемости' },
    ],
    isLoading: false,
    justpayRemainderService: null,
    nomenclatureSelection: [],
    pointSelection: [],
    report: { error: false, remainderResponses: [] },
    reportMain: { error: false, remainderResponses: [] },
    showResidualProduct: false,
    showNotMovedProduct: false,
    showZeroBalance: true,

  }),
  computed: {
    allPoints () {
      return this.form.points.length === this.pointSelection.length
    },
    somePoints () {
      return !this.allPoints && this.pointSelection.length > 0
    },
    iconSelectedPoints () {
      if (this.allPoints) return 'mdi-close-box'
      if (this.somePoints) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    allProducts () {
      return this.form.nomenclatures.length === this.nomenclatureSelection.length
    },
    someProducts () {
      return !this.allProducts && this.nomenclatureSelection.length > 0
    },
    iconSelectedProducts () {
      if (this.allProducts) return 'mdi-close-box'
      if (this.someProducts) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    }
  },
  beforeMount () {
    this.justpayRemainderService = new JustpayRemainderService()
  },
  async mounted () {
    const data = await this.justpayRemainderService.getInit()
    console.log('this.data', data)
    this.nomenclatureSelection = data.nomenclatures
    this.pointSelection = data.points
  },
  methods: {
    changeOption () {
      this.report = JSON.parse(JSON.stringify(this.reportMain))
      if (this.showResidualProduct) {
        this.report.remainderResponses = /* this.showResidualProduct ? this.report = JSON.parse(JSON.stringify(this.reportMain)) : */ this.report.remainderResponses.filter(f => f.remainderInPeriod > 0)
      }
      if (this.showNotMovedProduct) {
        this.report.remainderResponses = this.report.remainderResponses.filter(f => f.daysOnPoint > 30)
      }
      // if (!this.showZeroBalance) {
      //   this.report.remainderResponses = this.reportMain.remainderResponses.filter(f => f.remainderInPeriod >= 0)
      // }
      const pointSet = new Set()
      this.report.remainderResponses.forEach(f => {
        pointSet.add(f.pointName)
      })
      this.chosenPoints = pointSet.size
      this.goodsInStock = this.report.remainderResponses.filter(f => f.remainderInPeriod > 0).length
      this.allGoods = this.report.remainderResponses.length
      this.commonBalance = 0
      this.commonRemainder = 0
      this.report.remainderResponses.forEach(f => {
        this.commonBalance += f.balanceInPeriod
        this.commonRemainder += f.remainderInPeriod
      })
      const turnoverRatio = this.report.remainderResponses.filter(f => f.turnoverRatio > 0).reduce((acc, item) => acc + item.turnoverRatio, 0)
      this.averageTurnoverRatio = turnoverRatio / this.allGoods
    },
    onChangeOption () {
      this.changeOption()
    },
    onChoosePoint () {
      this.chosenPoints = this.form.points.length
    },
    async onReport () {
      console.log('this.form', this.form)
      this.isLoading = true
      this.reportMain = await this.justpayRemainderService.getReport(this.form)

      this.changeOption()

      this.isLoading = false
    },
    onTogglePoints () {
      this.$nextTick(() => {
        if (this.allPoints) {
          this.form.points = []
        } else {
          this.form.points = this.pointSelection.map(m => m.value)
          this.chosenPoints = this.form.points.length
        }
      })
    },
    onToggleProducts () {
      this.$nextTick(() => {
        if (this.allProducts) {
          this.form.nomenclatures = []
        } else {
          this.form.nomenclatures = this.nomenclatureSelection.map(m => m.value)
        }
      })
    }
  }
}
</script>
<style scoped>

</style>
